import API from "./axios"

/////////////////////////////////////////////////////
// ADD TO CART
/////////////////////////////////////////////////////

export const addToCartApi = (data) =>
  API.post("/add_to_cart", data)

/////////////////////////////////////////////////////
// UPDATE CART ITEM QUANTITY
/////////////////////////////////////////////////////

export const updateCartItemApi = (data) =>
  API.post("/update_cart_item_quantity", data)

/////////////////////////////////////////////////////
// DELETE CART ITEM
/////////////////////////////////////////////////////

export const deleteCartItemApi = (data) =>
  API.delete("/delete_cart_item", { data })

/////////////////////////////////////////////////////
// GET USER CART (WITH SELECTED VARIANT)
/////////////////////////////////////////////////////
export const getUserCartApi = (data) =>
  API.post("/get_user_cart", data)

/////////////////////////////////////////////////////
// GET USER CART INFO
/////////////////////////////////////////////////////

export const getUserCartInfoApi = () =>
  API.get("/get_user_cart_info")

/////////////////////////////////////////////////////
// GET CART TOTAL
/////////////////////////////////////////////////////

export const getCartTotalApi = (data) =>
  API.post("/get_cart_total", data)

/////////////////////////////////////////////////////
// ADMIN CART ITEMS
/////////////////////////////////////////////////////

export const getCartAdminApi = () =>
  API.get("/get_cart_items_admin")